import { render, staticRenderFns } from "./Main2019.vue?vue&type=template&id=53deac74"
import script from "./Main2019.vue?vue&type=script&lang=js"
export * from "./Main2019.vue?vue&type=script&lang=js"
import style0 from "./Main2019.vue?vue&type=style&index=0&id=53deac74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports